import React from "react"

const Spacer = ({ className = "" }) => {
	return <div className={"spacer " + className} />
}

export default Spacer
